import * as React from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { color } from "../../../styles";
import dayjs, { Dayjs } from "dayjs";
import { Box } from "@mui/material";

interface DateFilterProps {
    value: string | null;
    onChangeValue: (value: string | null) => void;
}

export default function DateFilter({ value, onChangeValue }: DateFilterProps) {
    const dayjsValue: Dayjs | null = value ? dayjs(value) : null;

    return (
        <Box
            data-testid="single-date-filter"
            sx={{
                width: "100%",
                maxWidth: "100%",
                minWidth: 0,
                overflow: "hidden",
                boxSizing: "border-box",
            }}
        >
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="vi">
                <DatePicker
                    value={dayjsValue}
                    onChange={(newValue) =>
                        onChangeValue(newValue ? newValue.format("YYYY-MM-DD") : null)
                    }
                    dayOfWeekFormatter={(date: Dayjs) => {
                        const weekdaysShort = ["CN", "T2", "T3", "T4", "T5", "T6", "T7"];
                        return weekdaysShort[date.day()];
                    }}
                    slotProps={{
                        textField: {
                            size: "small",
                            fullWidth: true,
                            sx: {
                                minWidth: 0,
                                maxWidth: "100%",
                                "& .MuiInputBase-root": {
                                    height: "30px",
                                    fontSize: "12px",
                                    fontFamily: "Noto Sans",
                                    paddingRight: "4px",
                                },
                                "& .MuiInputBase-input": {
                                    padding: "6px 4px 6px 8px",
                                    minWidth: 0,
                                },
                                "& .MuiIconButton-root": {
                                    padding: "2px",
                                    marginRight: "-2px",
                                },
                                "& .MuiSvgIcon-root": {
                                    fontSize: "18px",
                                },
                                "& fieldset": {
                                    border: `1px solid ${color.secondary.BORDER}`,
                                },
                            },
                        },
                    }}
                    sx={{
                        width: "100%",
                        maxWidth: "100%",
                        minWidth: 0,
                        display: "block",
                    }}
                />
            </LocalizationProvider>
        </Box>
    );
}
